import React from 'react';
import DashboardHeader from '../../components/Admin/DashboardHeader';
import DashboardSideBar from '../../components/Admin/DashboardSideBar';
import Colors from '../../components/Admin/Colors.jsx';

import './AdminColors.scss';

const AdminColors = () => {
  return (
    <div className="AdminParentColors">
      <DashboardHeader />

      <div className="dashboard-container">

        <div className="dashboard-inner">
          <div className="sidebar-wrapper">
            <DashboardSideBar active={7} />
          </div>
          <div className="products-container">
            <Colors />
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminColors;
